import { render, staticRenderFns } from "./ScreenBg.vue?vue&type=template&id=e962e290&"
import script from "./ScreenBg.vue?vue&type=script&lang=js&"
export * from "./ScreenBg.vue?vue&type=script&lang=js&"
import style0 from "./ScreenBg.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports